import Vue from 'vue'
import Vuex from 'vuex'
import { login, logout, getOrgInfo } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import CryptoJS from 'crypto-js'
import device from './device'
Vue.use(Vuex)

const EEG_SESSION_KEYS = ['eyeCalibratedPassed', 'eegCheckPassed', 'timeSyncExpireAt']

function clearEegSessionFlags() {
  EEG_SESSION_KEYS.forEach((key) => sessionStorage.removeItem(key))
}

// appVersionCode：ASDRe-SET-E1 脑电版，ASDRe-SET-01 标准版
function isEegProduct(orgInfo) {
  return !!(orgInfo && [3, 4].includes(orgInfo.appVersionCode))
}

export default new Vuex.Store({
  modules: {
    device
  },
  state: {
    userInfo: !['', 'null', 'undefined'].includes(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')) : {},
    token: getToken(),
    gameTrainObj: localStorage.getItem('gameTrainObj') ? JSON.parse(localStorage.getItem('gameTrainObj')) : {},
    gameAssessList: localStorage.getItem('gameAssessList') ? JSON.parse(localStorage.getItem('gameAssessList')) : [],
    trainLevelList: localStorage.getItem('trainLevelList') ? JSON.parse(localStorage.getItem('trainLevelList')) : [],
    storyObj: sessionStorage.getItem('story') ? JSON.parse(sessionStorage.getItem('story')) : {},  // 多绘本故事数组,
    storyDetails: sessionStorage.getItem('storyDetails') ? JSON.parse(sessionStorage.getItem('storyDetails')) : {}, // 绘本详情
    replaceCount: 0, // 用于记录当前页面是否被替换
    orgInfo: null
  },
  getters: {
    userInfo: state => state.userInfo,
    gameTrainObj: state => state.gameTrainObj,
    gameAssessList: state => state.gameAssessList,
    trainLevelList: state => state.trainLevelList,
    storyObj: state => state.storyObj,
    replaceCount: state => state.replaceCount,
    storyDetails: state => state.storyDetails,
    orgInfo: state => state.orgInfo,
    isEegEdition: state => isEegProduct(state.orgInfo)
  },
  mutations: {
    SET_USER_INFO: (state, userInfo) =>{
      state.userInfo = userInfo
    },
    SET_TOKEN: (state, token) =>  {
      state.token = token
    },
    SET_TRAIN_GAME_LIST: (state, gameTrainObj) =>  {
      state.gameTrainObj = gameTrainObj
    },
    SET_ASSESS_LIST: (state, assessList) =>  {
      state.gameAssessList = assessList
    },
    SET_TRAIN_LEVEL_LIST: (state, trainList) => {
      state.trainLevelList = trainList
    },
    SET_STORY: (state, story) => {
      state.storyObj = story
      sessionStorage.setItem('story', JSON.stringify(story))
    },
    SET_STORY_DETAIL: (state, story) => {
      state.storyDetails = story
      sessionStorage.setItem('storyDetails', JSON.stringify(story))
    },
    SET_REPLACE_COUNT: (state, replaceCount) => {
      state.replaceCount = replaceCount
    },
    SET_ORG_INFO: (state, orgInfo) => {
      state.orgInfo = orgInfo
    }

  },
  actions: {
    login({ commit }, userInfo) {
     const { username, password } = userInfo
      return new Promise((resolve, reject) => {
        login({ username: username.trim(), password: CryptoJS.MD5(password).toString(), uuid: '111111', code: '111111' }).then(response => {
          const { data } = response
          setToken(data.token)
          commit('SET_TOKEN', data.token)
          resolve({ token: data.token, username })
        }).catch(error => {
          reject(error)
        })
      })
    },
    async logout({ commit }) {
      return new Promise((resolve, reject) => {
        logout().then(() => {
           removeToken()
            commit('SET_USER_INFO', {})
            commit('SET_TOKEN', '')
            commit('SET_ORG_INFO', null)
            localStorage.removeItem('userInfo')
            localStorage.removeItem('gameAssessList')
            localStorage.removeItem('trainGameList')
            clearEegSessionFlags()
            resolve()
        }).catch(error => {
          reject(error)
        })
      })
     
    },
    // 获取组织信息
    fetchOrgInfo({ state, commit }) {
      if (state.orgInfo) return Promise.resolve(state.orgInfo)
      return getOrgInfo().then((res) => {
        const data = res && res.data ? res.data : null
        commit('SET_ORG_INFO', data)
        return data
      })
    },
    setUserInfo({ commit, state }, data) {
      const prevId = state.userInfo && state.userInfo.clientUserId
      const nextId = data && data.clientUserId
      if (prevId !== nextId) {
        clearEegSessionFlags()
      }
      commit('SET_USER_INFO', data)
      localStorage.setItem('userInfo', JSON.stringify(data))
    },
    // 设置训练游戏列表
    setTrainGameList({ commit }, data) {
      console.log(data)
      commit('SET_TRAIN_GAME_LIST', data)
      localStorage.setItem('gameTrainObj', JSON.stringify(data))
    },
    setTrainLevelList({ commit }, data) {
      console.log(data)
      commit('SET_TRAIN_LEVEL_LIST', data)
      localStorage.setItem('trainLevelList', JSON.stringify(data))
    },
    resetToken({ commit }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '')
        commit('SET_USER_INFO', {})
        commit('SET_ORG_INFO', null)
        removeToken()
        // 清除持久化的路由信息
        localStorage.removeItem('userInfo')
        localStorage.removeItem('gameAssessList')
        localStorage.removeItem('gameTrainObj')
        localStorage.removeItem('trainLevelList')
        clearEegSessionFlags()
        resolve()
      })
    },
    // 设置评估列表
    setAssessList({ commit }, data) {
      commit('SET_ASSESS_LIST', data)
      localStorage.setItem('gameAssessList', JSON.stringify(data))
    },
    // 绘本故事传参
    setStory({ commit }, data) {
      commit('SET_STORY', data)
    },
     setStroyDetails({ commit }, data) {
      commit('SET_STORY_DETAIL', data)
    },
    // 绘本路由跳转次数记录
    setReplaceCount({ commit }, data) {
      commit('SET_REPLACE_COUNT', data)
    }
  }
})
